import { render, staticRenderFns } from "./EtapaMenu.vue?vue&type=template&id=3b164275&scoped=true"
import script from "./EtapaMenu.vue?vue&type=script&lang=js"
export * from "./EtapaMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b164275",
  null
  
)

export default component.exports